module.exports = __webpack_public_path__ + "img/ko.36a18134.png";